import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const FlowsPage = lazy(() =>
  import('../pages/automation/FlowsPage').then((m) => ({ default: m.FlowsPage }))
)

export const automationRoutes: RouteObject[] = [
  {
    path: '/automation/flows',
    element: <FlowsPage />,
  },
]
